import React, { useState } from 'react';

const WordCounterTool: React.FC<{ slug?: string }> = () => {
  const [text, setText] = useState('');

  const words = text.trim() ? text.trim().split(/\s+/).filter(Boolean).length : 0;
  const chars = text.length;
  const charsNoSpaces = text.replace(/\s/g, '').length;
  const sentences = text.split(/[.!?]+/).filter(Boolean).length;
  const paragraphs = text.split(/\n\n+/).filter(Boolean).length;

  return (
    <div className="space-y-6">
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Paste or type your text here..."
        rows={8}
        className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-400 focus:border-orange-400 resize-none"
      />
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        <div className="bg-violet-50 rounded-lg p-4 border border-violet-100">
          <div className="text-2xl font-bold text-violet-600">{words}</div>
          <div className="text-sm text-gray-600">Words</div>
        </div>
        <div className="bg-violet-50 rounded-lg p-4 border border-violet-100">
          <div className="text-2xl font-bold text-violet-600">{chars}</div>
          <div className="text-sm text-gray-600">Characters</div>
        </div>
        <div className="bg-violet-50 rounded-lg p-4 border border-violet-100">
          <div className="text-2xl font-bold text-violet-600">{charsNoSpaces}</div>
          <div className="text-sm text-gray-600">No spaces</div>
        </div>
        <div className="bg-violet-50 rounded-lg p-4 border border-violet-100">
          <div className="text-2xl font-bold text-violet-600">{sentences}</div>
          <div className="text-sm text-gray-600">Sentences</div>
        </div>
      </div>
      <div className="text-sm text-gray-500">Paragraphs: {paragraphs}</div>
    </div>
  );
};

export default WordCounterTool;
